import { component } from 'picoapp'
import createCarousel from '../lib/carousel'

export default component((node, ctx) => {
  const instance = createCarousel(node)
  return () => {
    instance.destroy()
  }
})
